export class FetchDiscoverableWorkTypesError extends Error {

}
